import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { IconButton, Tooltip } from '@mui/material';

import { useThemeMode } from '../../theme/ThemeContext';

type Props = {
  collapsed?: boolean;
};

export default function ThemeToggle({ collapsed = false }: Props) {
  const { mode, toggleMode } = useThemeMode();
  const isDark = mode === 'dark';

  return (
    <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'} placement={collapsed ? 'right' : 'top'}>
      <IconButton
        onClick={toggleMode}
        size={collapsed ? 'small' : 'medium'}
        sx={{
          color: 'var(--text-secondary)',
          padding: collapsed ? '6px' : '8px',
          '&:hover': {
            color: 'var(--text-primary)',
            bgcolor: 'var(--surface-overlay)',
          },
          transition: 'all 0.2s ease',
        }}
      >
        {isDark ? (
          <LightModeIcon sx={{ fontSize: collapsed ? 18 : 20 }} />
        ) : (
          <DarkModeIcon sx={{ fontSize: collapsed ? 18 : 20 }} />
        )}
      </IconButton>
    </Tooltip>
  );
}
